import { ILogger } from '@cian/logger';

export function getCustomChatContext(context: string | null | undefined, logger: ILogger) {
  try {
    if (!context) {
      return undefined;
    }

    return JSON.parse(window.atob(context));
  } catch (error) {
    logger.warning('Не удалось распарсить контекст кастомного чата', { error });

    return undefined;
  }
}
